import React, { useContext, useState } from "react";
import PricingCard from "./PricingCard";
import { AuthContext, API_BASE_URL } from "../App";
import "./PricingCards.css";
import { trackEvent } from "../utils/mixpanel";

const PricingCards = ({ pricingData, handleSubscribe }) => {
  const [cycle, setCycle] = useState(pricingData.defaultCycle);
  const { authToken, user } = useContext(AuthContext);
  console.log(`User is "${user?.plan}"`);
  return (
    <div>
      {/* billing-cycle toggle */}
      <div className="billing-toggle">
        {pricingData.billingCycles.map((c) => (
          <button
            key={c}
            onClick={() => {
              trackEvent("Billing Cycle Changed", { cycle: c });
              setCycle(c);
            }}
            className={c === cycle ? "active" : ""}
          >
            {c === "yearly" ? "Yearly (Save 20%)" : "Monthly"}
          </button>
        ))}
      </div>
      <div className="pricing-cards">
        {Object.entries(pricingData.plans).map(([key, plan]) => {
          const priceValue = plan.price[cycle];
          const priceLabel =
            priceValue > 0
              ? `$${priceValue}${pricingData.cycleLabels[cycle].suffix}`
              : "-";
          const discountLabel = ""; //pricingData.cycleLabels[cycle].discountLabel;
          const buttonText =
            priceValue > 0
              ? authToken
                ? "Upgrade to Plus"
                : "Login to Subscribe"
              : authToken
              ? "Your Current Plan"
              : "Login to Use";
          const notes = plan.notes
            .filter((n) => !n.cycle || n.cycle === cycle)
            .map((n) => n.text);
          console.log("cycle", cycle);
          return (
            <PricingCard
              key={key}
              type={key}
              title={plan.title}
              price={priceLabel}
              discountLabel={discountLabel}
              features={plan.features}
              currentPlan={user?.plan}
              buttonText={buttonText}
              notes={notes}
              onButtonClick={handleSubscribe}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PricingCards;
